import React from "react"
import Header from "./header"
import { Container } from "react-bootstrap"
import Footer from "./footer"

const Layout = props => {
  return (
    <>
      <Header />
      <Container fluid style={{ backgroundColor: "#18191A" }}>
        {props.children}
      </Container>
      <Footer />
    </>
  )
}
export default Layout
